import { useEffect, useState } from 'react';

/**
 * `Date.now()`, re-read every `intervalMs` while `active`.
 *
 * For readouts that count (a timer face), so only the leaf that shows the
 * time re-renders each second - the same reason `SessionTimer` in the
 * practice runner ticks alone. Inactive, it returns the current time on each
 * render and schedules nothing.
 */
export function useNow(active: boolean, intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [active, intervalMs]);

  return active ? now : Date.now();
}
